/* SUSHI BIKE TABI „Dezent“ (27.10.2026) – Logik der Kaufkarte sections/sushi-dztb-main.liquid ([data-dztb]). Erzeugt von
   scripts/build_tabi_template.py aus assets/sushi-dezent-pdp.js (3.0+): Galerie, Warenkorb, Versand-Pop-up, Schritte und
   Kartenhöhe sind derselbe Code, die Bike-Init ist fürs TABI angepasst (Farbe je Rahmen, Größen genau wie die Varianten,
   Größenberatung nur mit Körpergröße, ausverkauft: „Sag mir Bescheid“ über Klaviyo + passendes SUSHI BIKE 3.0+). Reiter von
   „Dezent Details“ wie dort. Änderungen bitte im Generator. */
(function () {
  if (window.__sushiDztb) return;  /* nur einmal ausführen */
  window.__sushiDztb = true;
  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const esc = (s) => String(s).replace(/[&<>"]/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]));
  const eur = (c) => (c / 100).toLocaleString('de-DE', { minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 }) + ' €';
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  /* Bot-Schutz der Anmeldeformulare (31.10.2026): unsichtbares Feld „website“, das nur Bots ausfüllen, und mindestens 2 s zwischen
     Laden der Seite und Absenden. Trifft eins zu, zeigt das Formular „Danke“, schickt aber nichts an Klaviyo. */
  const HP_T0 = Date.now();
  const hpAdd = (f) => { if (f && !f.querySelector('.sushi-hp')) f.insertAdjacentHTML('beforeend', '<input class="sushi-hp" type="text" name="website" value="" tabindex="-1" autocomplete="off" aria-hidden="true" style="position:absolute;width:1px;height:1px;margin:-1px;padding:0;border:0;overflow:hidden;clip:rect(0 0 0 0);clip-path:inset(50%);opacity:0;pointer-events:none">'); };
  const hpBot = (f) => { const h = f.querySelector('.sushi-hp'); return !!(h && h.value) || Date.now() - HP_T0 < 2000; };
  const uniq = (a) => [...new Set(a)];

  /* Größe aus dem Optionswert: „S (< 172 cm)“ → [0, 172] und ['S', 'bis 172 cm']; „Einheitsgröße (160 - 180 cm)“ → ['Eine Größe', '160–180 cm'] */
  function range(value) {
    const m = /\(([^)]*)\)/.exec(value || '');
    if (!m) return null;
    const s = m[1], n = (s.match(/\d+/g) || []).map(Number);
    if (/</.test(s) && n[0]) return [0, n[0]];
    if (/>/.test(s) && n[0]) return [n[0], 999];
    return n.length >= 2 ? [n[0], n[1]] : null;
  }
  function sizeLabel(value) {
    const name = value.split(' (')[0], m = /\(([^)]*)\)/.exec(value);
    const sub = m ? m[1].replace('< ', 'bis ').replace('> ', 'ab ').replace(/\s*-\s*/, '–') : '';
    return [/^Einheit/i.test(name) ? 'Eine Größe' : name, sub];
  }
  const short = (m) => m.replace(/\s*\d.*$/, '');

  function tabs() {
    document.addEventListener('click', (e) => {
      const t = e.target.closest('.pdt-nav [role=tab]');
      if (!t) return;
      $$('[role=tab]', t.parentElement).forEach((b) => {
        const on = b === t;
        b.setAttribute('aria-selected', on);
        b.tabIndex = on ? 0 : -1;
        const p = document.getElementById(b.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
    });
  }

  /* ------------------------------------------------------------------ gemeinsam */

  /* Galerie: list = [{u: Bild-URL mit width=1200, a: Alt-Text}] */
  function gallery(el, list) {
    const g = $('[data-gallery]', el), main = g && $('[data-gallery-main]', g), th = g && $('[data-gallery-thumbs]', g);
    if (!list.length || !main) return;
    const show = (m) => { main.src = m.u; main.srcset = [600, 900, 1200].map((w) => m.u.replace('width=1200', 'width=' + w) + ' ' + w + 'w').join(', '); main.alt = m.a || ''; };
    show(list[0]);
    th.innerHTML = list.map((m, i) => `<button type="button" class="${i ? '' : 'on'}" data-i="${i}" aria-label="Bild ${i + 1}"><img src="${esc(m.u.replace('width=1200', 'width=160'))}" alt="" loading="lazy" width="80" height="80"></button>`).join('');
    th.scrollLeft = 0;
    th.onclick = (e) => { const b = e.target.closest('button'); if (!b) return; show(list[+b.dataset.i]); $$('button', th).forEach((x) => x.classList.toggle('on', x === b)); };
  }

  /* Warenkorb: Positionen per /cart/add.js, danach Cart-Drawer bzw. -Notification des Themes (wie sushi-pdp.js) */
  async function addToCart(items, btn, done, T, variantId) {
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const body = { items };
    if (cart && cart.getSectionsToRender) {
      body.sections = cart.getSectionsToRender().map((s) => s.id);
      body.sections_url = location.pathname;
      if (cart.setActiveElement) cart.setActiveElement(btn);
    }
    btn.disabled = true;
    done.hidden = true;
    try {
      const r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      const res = await r.json();
      if (!r.ok || res.status) throw res;
      const first = res.items && res.items[0];
      if (first) { res.key = first.key; res.id = first.variant_id; }
      if (typeof publish === 'function' && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sushi-dezent-pdp', productVariantId: variantId, cartData: res });
      if (cart && cart.renderContents && res.sections) { cart.classList.remove('is-empty'); cart.renderContents(res); } else location.href = root + 'cart';
    } catch (err) {
      done.textContent = (err && err.description) || T.cartError;
      done.hidden = false;
    } finally { btn.disabled = false; }
  }

  /* Versandkosten (#vk). lands = [{name, bike, more, acc, carrier}], text() → Satz „Für deine Auswahl“ */
  function shipping(vk, lands, rest, text) {
    let L = 0;
    function calc() {
      const c = lands[L] || lands[0];
      $$('[data-vk-land]', vk).forEach((b) => b.setAttribute('aria-pressed', +b.dataset.vkLand === L));
      $$('[data-vk]', vk).forEach((d) => (d.textContent = c[d.dataset.vk] || ''));
      $('[data-vk-big]', vk).textContent = c.bike;
      $('[data-vk-title]', vk).textContent = 'Versand nach ' + c.name;
      $('[data-vk-text]', vk).textContent = text();
      $('[data-vk-carrier]', vk).textContent = `Versandpartner: Bike ${c.carrier}` + (rest ? ' · ' + rest : '');
    }
    vk.addEventListener('click', (e) => {
      const t = e.target;
      if (t.closest('[data-vk-close]') || t === vk) { vk.close(); return; }
      const l = t.closest('[data-vk-land]'); if (l) { L = +l.dataset.vkLand; calc(); }
    });
    return { open() { calc(); vk.showModal(); } };
  }

  /* Schritte der Kaufkarte; names = Schrittnamen, last = Text des Buttons vor der Übersicht */
  function steps(el, names, T) {
    let STEP = 0;
    const max = names.length - 1;
    function show(i, scroll) {
      STEP = Math.max(0, Math.min(max, i));
      $$('[data-step]', el).forEach((s) => s.classList.toggle('on', +s.dataset.step === STEP));
      $$('.p3-prog [data-goto]', el).forEach((b) => { const n = +b.dataset.goto; b.classList.toggle('on', n === STEP); b.classList.toggle('done', n < STEP); b.setAttribute('aria-current', n === STEP ? 'step' : 'false'); });
      $('[data-back]', el).hidden = STEP === 0;
      const nx = $('[data-next]', el);
      nx.hidden = STEP === max;
      nx.textContent = STEP === max - 1 ? T.toSummary : T.next + ': ' + names[STEP + 1];
      if (scroll) { const c = $('.p3-card', el), top = c.getBoundingClientRect().top; if (top < 0 || top > innerHeight * 0.6) c.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    }
    return { show, get: () => STEP, max };
  }

  /* Card beginnt bündig mit dem Bild: Höhe des Titels links */
  function headHeight(el) {
    const head = $('.p3-head', el), grid = $('.p3-grid', el);
    if (!head || !grid) return;
    const set = () => grid.style.setProperty('--p3-head', head.offsetHeight + 'px');
    if ('ResizeObserver' in window) new ResizeObserver(set).observe(head);
    set();
  }

  /* Klicks außerhalb der Section (z. B. „Dezent Details“): nur der Button zur Größenberatung öffnet das Pop-up */
  function outside(el, open) {
    document.addEventListener('click', (e) => {
      if (!el.isConnected || el.contains(e.target)) return;  /* im Theme-Editor neu geladene Section */
      if (e.target.closest('[data-sg-open]')) open();
    });
  }


  /* ------------------------------------------------------------------ TABI */
  const word = (m) => String(m).split(' - ').pop();  /* „TABI - Diamantrahmen“ → „Diamantrahmen“ */

  /* Größe genau wie der Optionswert im Shop: „S (< 170 cm)“ = unter 170, „M (170 - 180 cm)“ = 170 bis 180, „XL (> 185 cm)“ = über 185 */
  function tbRange(value) {
    const m = /\(([^)]*)\)/.exec(value || '');
    if (!m) return null;
    const s = m[1], n = (s.match(/\d+/g) || []).map(Number);
    if (/</.test(s) && n[0]) return [0, n[0] - 1];
    if (/>/.test(s) && n[0]) return [n[0] + 1, 999];
    return n.length >= 2 ? [n[0], n[1]] : null;
  }
  function tbLabel(value) {
    const name = String(value).split(' (')[0], m = /\(([^)]*)\)/.exec(value);
    return [name, m ? m[1].replace('< ', 'unter ').replace('> ', 'über ').replace(/\s*-\s*/, '–') : ''];
  }

  /* Ausverkauft: passendes SUSHI BIKE 3.0+ (D.alt) für dieselbe Körpergröße – je Modell die Größe mit der größten Überschneidung
     (Größen des 3.0+ wie auf seiner Seite), gleicher Rahmen zuerst */
  function altList(D, v) {
    const A = D.alt, r = tbRange(v.o[1]);
    if (!A || !A.variants || !A.variants.length || !r) return [];
    const over = (a, b) => Math.min(a[1], b[1]) - Math.max(a[0], b[0]), out = [];
    A.models.forEach((am) => {
      const vs = A.variants.filter((x) => x.o[0] === am.m);
      let best = null, bo = 0;
      uniq(vs.map((x) => x.o[1])).forEach((s) => { const o = over(r, range(s) || [0, 999]); if (o > bo) { bo = o; best = s; } });
      if (!best) return;
      const ok = vs.filter((x) => x.o[1] === best && x.av);
      out.push({ am, s: best, pick: ok[0] || vs.find((x) => x.o[1] === best), cols: uniq(ok.map((x) => x.o[2])), same: am.f === word(v.o[0]) ? 1 : 0 });
    });
    return out.sort((a, b) => b.same - a.same);
  }
  function altUrl(D, o) { return (D.alt.url || '') + '?variant=' + o.pick.id; }
  function altName(o) { const l = sizeLabel(o.s); return 'das ' + o.am.m + (/^Eine/.test(l[0]) ? '' : ' in ' + l[0]); }
  function alts(el, D, v) {
    const wrap = $('[data-alt-wrap]', el), box = $('[data-alts]', el);
    if (!wrap || !box) return;
    const list = v.av ? [] : altList(D, v);
    box.innerHTML = list.map((o) => {
      const l = sizeLabel(o.s), n = altName(o), p = o.pick;
      const st = o.cols.length ? `<small><i class="ok"></i>Lieferbar in ${esc(o.cols.join(', '))}</small>` : '<small><i></i>Gerade auch ausverkauft</small>';
      const im = o.am.img ? `<img src="${esc(o.am.img)}" alt=""${o.am.sq ? ' class="sq"' : ''} width="400" height="250" loading="lazy">` : '';
      return `<a class="tb-alt" href="${esc(altUrl(D, o))}">${im}<b>${esc(n.charAt(0).toUpperCase() + n.slice(1))}</b><span>${esc(o.am.f + ' · ' + l[1])}</span>${st}` +
        `<p class="dz-price"><b>${eur(p.p)}</b>${p.c > p.p ? '<s>' + eur(p.c) + '</s>' : ''}</p></a>`;
    }).join('');
    wrap.hidden = !list.length;
  }
  function altShort(D, v) {
    const list = v && !v.av ? altList(D, v) : [];
    if (!list.length) return '';
    return '<p class="sg__alt">Stattdessen passt ' + list.map((o) => `<a href="${esc(altUrl(D, o))}">${esc(altName(o))}</a> ` +
      (o.cols.length ? `(lieferbar in ${esc(o.cols.join(', '))})` : '(auch ausverkauft)')).join(' oder ') + '.</p>';
  }

  /* „Sag mir Bescheid“: zwei Anmeldungen bei Klaviyo (Client-API). 1) Back in Stock für die gewählte Variante – Klaviyo schickt die
     Mail „wieder da“ automatisch, sobald genau diese Variante wieder Bestand hat (Flow „Back In Stock Flow - Standard“). 2) Newsletter
     wie die B-Ware-Formulare (Liste data-list, Double-Opt-in) mit den Profil-Eigenschaften back_in_stock (data-prop, z. B. „TABI“) und
     back_in_stock_variant (Variantentitel). Fehler zeigt das Formular nur, wenn die Back-in-Stock-Anmeldung scheitert. */
  function subscribe(f, cur) {
    const box = f.parentNode, err = $('[data-tb-err]', box), ok = $('[data-tb-ok]', box);
    hpAdd(f);
    f.addEventListener('submit', async (e) => {
      e.preventDefault();
      const inp = $('input[type=email]', f), btn = $('button', f), v = cur();
      if (!inp.checkValidity()) { inp.reportValidity(); return; }
      if (hpBot(f)) { f.hidden = true; if (ok) ok.hidden = false; return; }
      const props = {};
      if (f.dataset.prop) { props.back_in_stock = f.dataset.prop; props.back_in_stock_variant = (v && v.t) || ''; }
      const body = { data: { type: 'subscription', attributes: { custom_source: f.dataset.source || 'TABI PDP',
        profile: { data: { type: 'profile', attributes: { email: inp.value.trim(), properties: props, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
        relationships: { list: { data: { type: 'list', id: f.dataset.list } } } } };
      const company = f.dataset.company || 'Xz24E7';
      const post = (path, b) => fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + company, {
        method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2026-10-15' }, body: JSON.stringify(b) });
      const bis = v && { data: { type: 'back-in-stock-subscription', attributes: { channels: ['EMAIL'],
        profile: { data: { type: 'profile', attributes: { email: inp.value.trim() } } } },
        relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + v.id } } } } };
      btn.disabled = true;
      if (err) err.hidden = true;
      try {
        const [rb, rn] = await Promise.all([bis ? post('back-in-stock-subscriptions', bis) : null, post('subscriptions', body).catch(() => null)]);
        if (bis ? !rb.ok : !(rn && rn.ok)) throw new Error('klaviyo');
        f.hidden = true;
        if (ok) ok.hidden = false;
      } catch (x) { if (err) err.hidden = false; } finally { btn.disabled = false; }
    });
  }

  /* Größenberatung (#sg) fürs TABI: nur Körpergröße. A = { models, sizesOf(m), fitsOf(m, h), avail(m, s), label(m), out, alt(m, s), apply(m, s, h) } */
  function tbSizeGuide(dlg, A) {
    let M = A.models[0];
    function segs(m) {
      const rs = A.sizesOf(m).map((s) => [s, tbRange(s)]).filter((x) => x[1]);
      const pts = uniq([150, 201].concat(...rs.map((x) => [x[1][0], x[1][1] + 1])).filter((p) => p >= 150 && p <= 201)).sort((a, b) => a - b);
      const out = [];
      for (let i = 0; i < pts.length - 1; i++) {
        const a = pts[i], b = pts[i + 1], fit = rs.filter((x) => a >= x[1][0] && a <= x[1][1]).map((x) => tbLabel(x[0])[0]);
        out.push({ a, b, l: b - a >= 4 ? fit.join('/') || '–' : '' });
      }
      return out;
    }
    function calc() {
      const h = +$('[data-sg-h]', dlg).value;
      $('[data-sg-hout]', dlg).textContent = h + ' cm';
      $$('[data-sg-model]', dlg).forEach((b) => b.setAttribute('aria-pressed', b.dataset.sgModel === M));
      const sg = segs(M), act = sg.find((s) => h >= s.a && h < s.b);
      $('[data-sg-hscale]', dlg).innerHTML = sg.map((s) => `<span class="${s === act ? 'on' : ''}" style="left:${(s.a - 150) / 51 * 100}%;width:${(s.b - s.a) / 51 * 100}%"><em>${esc(s.l)}</em></span>`).join('');
      const fits = A.fitsOf(M, h);
      let big, title, text, stock = '', btns = '';
      if (!fits.length) {
        const other = A.models.find((x) => x !== M && A.fitsOf(x, h).length);
        const max = Math.max(...A.sizesOf(M).map((s) => (tbRange(s) || [0, 0])[1]).filter((x) => x < 999));
        big = '–';
        title = `Den ${word(M)} gibt es bis ${max} cm.`;
        text = other ? `Mit ${h} cm sitzt du auf dem ${esc(word(other))} richtig.` : 'Für deine Körpergröße haben wir keine passende Rahmengröße.';
        if (other) btns = `<button type="button" class="dz-btn" data-sg-switch="${esc(other)}">Zum ${esc(word(other))}</button>`;
      } else {
        const ls = fits.map((s) => tbLabel(s)[0]), av = fits.filter((s) => A.avail(M, s));
        big = ls.join(' / ');
        title = `${A.label(M)} in Größe ${ls.join(' oder ')}`;
        text = fits.length > 1 ? `Bei ${h} cm überschneiden sich unsere Größenangaben (${esc(fits.map((s) => tbLabel(s).join(': ')).join(', '))}) – beide passen.`
          : `Größe ${esc(ls[0])} ist für ${esc(tbLabel(fits[0])[1])} gemacht.`;
        stock = av.length ? `<p class="sg__stock"><i class="ok"></i>Lieferbar: Größe ${esc(av.map((s) => tbLabel(s)[0]).join(', '))}</p>`
          : `<p class="sg__stock"><i></i>${esc(A.out)}</p>` + A.alt(M, fits[0]);
        btns = av.concat(fits.filter((s) => !A.avail(M, s))).map((s, i) => `<button type="button" class="dz-btn${i ? ' dz-btn--ghost sg__alt-btn' : ''}" data-sg-apply data-key="${esc(s)}">Größe ${esc(tbLabel(s)[0])} übernehmen</button>`).join('');
      }
      $('[data-sg-result]', dlg).innerHTML = `<p class="dz-eye">Unsere Empfehlung</p><p class="sg__big">${esc(big)}</p><h3>${esc(title)}</h3><p>${text}</p>${stock}${btns}`;
    }
    dlg.addEventListener('click', (e) => {
      const t = e.target;
      if (t.closest('[data-sg-close]') || t === dlg) { dlg.close(); return; }
      const sm = t.closest('[data-sg-model]'); if (sm) { M = sm.dataset.sgModel; calc(); return; }
      const sw = t.closest('[data-sg-switch]'); if (sw) { M = sw.dataset.sgSwitch; calc(); return; }
      const a = t.closest('[data-sg-apply]'); if (a) { A.apply(M, a.dataset.key, +$('[data-sg-h]', dlg).value); dlg.close(); }
    });
    dlg.addEventListener('input', calc);
    return { open(model, h) { M = A.models.includes(model) ? model : A.models[0]; if (h) $('[data-sg-h]', dlg).value = h; calc(); dlg.showModal(); } };
  }

  /* ------------------------------------------------------------------ TABI-PDP (Bike-PDP 3.0+, angepasst) */
  function initTabi(el) {
    const json = $('[data-dztb-json]', el);
    if (!json || el.dataset.ready) return;
    el.dataset.ready = '1';
    const D = JSON.parse(json.textContent), T = D.texts, low = +el.dataset.low || 10;
    const label = (m) => (D.labels && D.labels[m]) || m;
    let touched = false;
    D.extras = $$('[data-extra]', el).map((b) => ({ id: +b.dataset.extra, p: +b.dataset.price, t: b.dataset.title }));
    const idIn = $('[data-id]', el), dnote = $('[data-dnote]', el), form = $('.pd-form', el), done = $('[data-done]', el);
    const v0 = D.variants.find((v) => v.id === +idIn.value) || D.variants[0];
    const S = { model: v0.o[0], size: v0.o[1], color: v0.o[2], extras: new Set() };
    const vOf = (m) => D.variants.filter((v) => v.o[0] === m);
    const find = (m, s, c) => D.variants.find((v) => v.o[0] === m && v.o[1] === s && v.o[2] === c);
    const sizesOf = (m) => uniq(vOf(m).map((v) => v.o[1]));
    const fitsOf = (m, h) => sizesOf(m).filter((x) => { const r = tbRange(x); return r && h >= r[0] && h <= r[1]; });
    const avail = (m, s) => vOf(m).some((x) => x.o[1] === s && x.av);
    const colorsOf = (m) => Object.keys(D.colors).filter((c) => vOf(m).some((v) => v.o[2] === c));
    const models = uniq(D.variants.map((v) => v.o[0]));
    const cur = () => find(S.model, S.size, S.color);
    const lowQ = (v) => v.q != null && v.q > 0 && v.q <= low;

    function defaults(m) {
      const hs = touched && hr ? sizeFor(+hr.value, m) : null;
      const v = (hs && (vOf(m).find((x) => x.o[1] === hs && x.av) || vOf(m).find((x) => x.o[1] === hs))) || vOf(m).find((x) => x.av) || vOf(m)[0];
      S.size = v.o[1]; S.color = v.o[2];
    }
    function setModel(m) { if (S.model === m) return; S.model = m; defaults(m); render(); }
    function setSize(s) { S.size = s; const v = cur(); if (!v || !v.av) { const a = vOf(S.model).find((x) => x.o[1] === s && x.av); if (a) S.color = a.o[2]; } render(); }
    function setColor(c) { S.color = c; const v = cur(); if (!v || !v.av) { const a = vOf(S.model).find((x) => x.o[2] === c && x.av); if (a) S.size = a.o[1]; } render(); }
    function sizeFor(h, m) { const mm = m || S.model, f = fitsOf(mm, h); return f.find((x) => avail(mm, x)) || f[0]; }

    /* Galerie: Produktbilder, deren Alt-Text mit dem Galerie-Präfix des Rahmens beginnt (Einstellung „Modell 1/2 – Galerie“) */
    function pics() {
      const prefix = (D.gallery && D.gallery[S.model]) || S.model;
      return D.media.filter((m) => (m.a || '').indexOf(prefix) === 0);
    }

    const set = (k, h) => $$('[data-out="' + k + '"]', el).forEach((e) => (e.innerHTML = h));
    let lastV = null;
    function render() {
      const v = cur();
      if (!v) return;
      $$('[data-model]', el).forEach((b) => b.setAttribute('aria-pressed', b.dataset.model === S.model));
      $$('[data-sizes]', el).forEach((box) => {
        box.innerHTML = sizesOf(S.model).map((s) => {
          const l = tbLabel(s), av = vOf(S.model).some((x) => x.o[1] === s && x.av);
          return `<button type="button" class="pd-size${av ? '' : ' out'}" data-size="${esc(s)}" aria-pressed="${s === S.size}"><b>${esc(l[0])}</b><small>${esc(l[1])}${av ? '' : ' · ausverkauft'}</small></button>`;
        }).join('');
      });
      $$('[data-colors]', el).forEach((box) => {
        box.innerHTML = colorsOf(S.model).map((c) => {
          const x = find(S.model, S.size, c), av = x && x.av;
          return `<button type="button" class="pd-color${av ? '' : ' out'}" data-color="${esc(c)}" aria-pressed="${c === S.color}"><i style="background:${esc(D.colors[c])}"></i><b>${esc(c)}</b><small>${av ? (lowQ(x) ? 'nur noch ' + x.q : 'lieferbar') : 'ausverkauft'}</small></button>`;
        }).join('');
      });
      const ex = D.extras.filter((e) => S.extras.has(e.id)), exSum = ex.reduce((a, e) => a + e.p, 0);
      $$('[data-extra]', el).forEach((b) => b.setAttribute('aria-pressed', S.extras.has(+b.dataset.extra)));
      const total = v.p + exSum, cmp = (v.c > v.p ? v.c : v.p) + exSum, save = v.c - v.p;
      set('price', eur(total));
      set('compare', cmp > total ? eur(cmp) : '');
      set('save', save > 0 ? esc(T.save.replace('[betrag]', eur(save))) : '');
      if (T.rate) set('rate', esc(T.rate.replace('[betrag]', eur(Math.floor(total / 12)))) + '<a class="dz-fn" href="#fussnoten" aria-label="Fußnote: Pflichtangaben zur Ratenzahlung">*</a>');
      let stock;
      if (v.av) {
        let t = v.d && !/^sofort versandbereit/i.test(v.d) ? v.d : T.ready;
        if (lowQ(v)) t = T.lowStock.replace('[anzahl]', v.q) + ' · ' + t;
        stock = `<i class="${v.ds === 'yellow' ? 'low' : 'ok'}"></i>${esc(t)}`;
      } else stock = `<i></i>${esc(T.soldout)}`;
      set('stock', stock);
      set('barlabel', esc(label(S.model) + ' · ' + S.color));
      set('barprice', eur(total) + (cmp > total ? ' <s>' + eur(cmp) + '</s>' : ''));
      $$('[data-cta]', el).forEach((b) => (b.hidden = !v.av));
      $$('[data-out="rate"]', el).forEach((e) => (e.hidden = !v.av));
      if (lastV !== v.id) {
        lastV = v.id;
        $$('[data-tb-notify]', el).forEach((f) => (f.hidden = false));
        $$('[data-tb-ok], [data-tb-err]', el).forEach((x) => (x.hidden = true));
        $$('[data-done]', el).forEach((d) => (d.hidden = true));
        idIn.value = v.id;
        const note = v.ov || v.dd ? 'Voraussichtliche Lieferung: ' + (v.ov || v.dd) : '';
        dnote.value = note;
        dnote.disabled = !note;
        if (location.search.includes('variant=') || v.id !== v0.id) {
          const url = new URL(location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState(history.state, '', url.toString());
        }
      }
      $$('[data-soldout]', el).forEach((b) => (b.hidden = v.av));
      alts(el, D, v);
      $$('[data-bundle-hint]', el).forEach((h) => (h.hidden = !!h.dataset.bundleHint && h.dataset.bundleHint !== S.model));
      review(ex);
      gallery(el, pics());
      fit();
    }

    /* Übersicht: Auswahl mit „ändern“ */
    function review(ex) {
      const r = $('[data-review]', el);
      if (!r) return;
      const row = (k, val, go) => `<li><span>${esc(k)}</span><b>${esc(val)}<button type="button" data-goto="${go}">${esc(T.change)}</button></b></li>`;
      const l = tbLabel(S.size);
      r.innerHTML = row(T.steps[0], label(S.model), 0) + row(T.steps[1], l.filter(Boolean).join(' · '), 1) + row(T.steps[2], S.color, 2) +
        row(T.steps[3], ex.length ? ex.map((e) => e.t.replace('SUSHI BIKES ', '')).join(', ') : T.noExtras, 3);
    }

    /* Körpergröße → Empfehlung im Schritt „Größe“ (überschneiden sich die Größenangaben, nennen wir beide) */
    function fit() {
      const r = $('[data-height]', el);
      if (!r) return;
      const h = +r.value, fits = fitsOf(S.model, h);
      $$('[data-out="height"]', el).forEach((e) => (e.textContent = h + ' cm'));
      let t;
      if (!fits.length) {
        const other = models.find((m) => m !== S.model && fitsOf(m, h).length);
        t = other ? `Mit ${h} cm passt der <button type="button" class="dz-link" data-model="${esc(other)}">${esc(word(other))}</button> besser.`
          : `Für ${h} cm: bitte zur <button type="button" class="dz-link" data-sg-open>Größenberatung</button>.`;
      } else {
        const ls = fits.map((s) => tbLabel(s)[0]);
        t = `Empfohlen: <b>Größe ${esc(ls.join(' oder '))}</b>` + (fits.length > 1 ? ' – hier überschneiden sich unsere Größenangaben' : ` (${esc(tbLabel(fits[0])[1])})`) +
          (fits.some((s) => avail(S.model, s)) ? '' : ' · gerade ausverkauft');
      }
      $$('[data-out="fit"]', el).forEach((e) => (e.innerHTML = t));
    }

    const step = steps(el, T.steps, T);
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const v = cur();
      if (!v || !v.av) return;
      const items = [{ id: v.id, quantity: 1, properties: dnote.disabled ? {} : { __delivery_note: dnote.value } }];
      S.extras.forEach((id) => items.push({ id, quantity: 1 }));
      addToCart(items, $('[data-cta]', el), done, T, v.id);
    });
    $$('[data-tb-notify]', el).forEach((f) => subscribe(f, cur));

    const dlg = $('#sg', el), vk = $('#vk', el), hr = $('[data-height]', el);
    const sg = dlg && tbSizeGuide(dlg, {
      models: $$('[data-sg-model]', dlg).map((b) => b.dataset.sgModel), sizesOf, fitsOf, avail, label, out: T.soldout,
      alt: (m, s) => altShort(D, vOf(m).find((x) => x.o[1] === s)),
      apply: (m, s, h) => { if (hr) hr.value = h; touched = true; if (S.model !== m) { S.model = m; defaults(m); } setSize(s); },
    });
    const ship = vk && shipping(vk, D.vk, T.carrierRest, () => `Dein ${label(S.model)} in ${S.color}` + (S.extras.size ? ' samt Zubehör – alles in einem Versandpreis.' : '. Bestellst du Zubehör dazu, ist es im Versandpreis schon drin.'));
    const openSg = () => sg && sg.open(S.model, hr && hr.value);
    outside(el, openSg);

    el.addEventListener('click', (e) => {
      const t = e.target;
      const m = t.closest('[data-model]'); if (m) { setModel(m.dataset.model); return; }
      const s = t.closest('[data-size]'); if (s) { setSize(s.dataset.size); return; }
      const c = t.closest('[data-color]'); if (c) { setColor(c.dataset.color); return; }
      const x = t.closest('[data-extra]'); if (x) { const id = +x.dataset.extra; S.extras.has(id) ? S.extras.delete(id) : S.extras.add(id); render(); return; }
      const g = t.closest('[data-goto]'); if (g) { step.show(+g.dataset.goto, g.closest('[data-review]')); return; }
      if (t.closest('[data-next]')) { step.show(step.get() + 1, true); return; }
      if (t.closest('[data-back]')) { step.show(step.get() - 1, true); return; }
      if (t.closest('[data-bar-cta]')) { e.preventDefault(); step.show(step.max); $('.p3-card', el).scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
      if (t.closest('[data-sg-open]')) { openSg(); return; }
      if (ship && t.closest('[data-vk-open]')) ship.open();
    });
    el.addEventListener('input', (e) => {
      if (e.target.matches('[data-height]')) { touched = true; fit(); const s = sizeFor(+e.target.value); if (s && s !== S.size) setSize(s); }
    });
    headHeight(el);
    /* Startgröße des Körpergrößen-Reglers passend zur Variante aus der URL */
    const r0 = tbRange(S.size);
    if (hr && r0) hr.value = Math.round((Math.max(r0[0], +hr.min) + Math.min(r0[1], +hr.max)) / 2);
    /* Link mit fertiger Auswahl (?variant=…&uebersicht=1, z. B. Startseite): direkt in die Übersicht */
    const sp = new URLSearchParams(location.search), lv = D.variants.find((v) => v.id === +sp.get('variant'));
    step.show(D.startSummary && sp.has('uebersicht') && lv && lv.av ? step.max : 0);
    render();
  }

  function boot() { $$('[data-dztb]').forEach(initTabi); }
  tabs();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
